import styled from 'styled-components';

export const ArtistContainer = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #555555;
  font-size: 24px;
  line-height: 32px;
  gap: 32px;
  color: #f6f8fe;
`;

export const ArtistArtworkStyled = styled.img`
  height: 120px;
`;

export const MetricsContainer = styled.div`
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;
  height: 106px;
  width: 100%;
`;

export const MetricItem = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #555555;
  border-right: 1px solid #555555;
  padding: 24px 0 0 24px;
  background: #19191b;

  &:first-child {
    border-left: 1px solid #555555;
  }
`;

export const MetricValue = styled.span`
  font-size: 32px;
  line-height: 38px;
  color: #f2f2f2;
`;

export const MetricUnit = styled.span`
  font-size: 14px;
  line-height: 20px;

  color: #9c9c9c;
`;
